import React from 'react'
import { appRoutes } from '@/constants'
import { useNavigate, Link } from 'react-router-dom'

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()
  const navigate = useNavigate()

  const footerSections = [
    {
      title: 'Quest-Lock',
      links: [
        { name: 'Home', href: appRoutes.marketing },
        { name: 'Authenticator', href: appRoutes.home },
        { name: 'Password Generator', href: appRoutes.passwordGenerator }
      ]
    },
    {
      title: 'Support & Info',
      links: [
        { name: 'Contact Us', href: appRoutes.contact },
        { name: 'Privacy Policy', href: appRoutes.privacyPolicy },
        { name: 'Terms of Service', href: appRoutes.termsOfService }
      ]
    }
  ]

  return (
    <footer className="border-shire-bark/20 bg-shire-light relative overflow-hidden border-t-2 shadow-inner">
      <div className="relative mx-auto max-w-6xl px-6 py-8 text-center">
        <div className="mb-8 lg:mb-6">
          <div className="flex items-center justify-start gap-4">
            <div className="relative">
              <img
                onClick={() => navigate(appRoutes.home)}
                src="/favicon/header-logo.webp"
                className="size-12 cursor-pointer rounded-xl lg:size-14"
                alt="Quest-Lock Logo"
                loading="lazy"
              />
            </div>
            <div>
              <h3 className="font-heading text-shire-dark mb-1 text-2xl lg:text-3xl">
                Quest-Lock
              </h3>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-8 lg:grid-cols-2 lg:gap-12">
          {footerSections.map((section, index) => (
            <div key={index} className="space-y-4">
              <div className="relative">
                <h4 className="font-heading text-shire-dark mb-1 text-lg font-semibold lg:text-xl">
                  {section.title}
                </h4>
                <div className="bg-shire-sun mx-auto h-1 w-16 rounded-full lg:w-20"></div>
              </div>

              <ul className="space-y-3 lg:space-y-4">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      to={link.href}
                      className="text-shire-bark hover:text-shire-dark cursor-pointer text-sm transition-all hover:underline lg:text-base"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="border-shire-bark/20 bg-shire-stone/50 relative border-t backdrop-blur-sm">
        <div className="mx-auto max-w-6xl p-6">
          <div className="flex flex-col items-center justify-between gap-4 sm:flex-row">
            <div className="font-ui text-shire-bark flex flex-wrap items-center gap-6 text-sm">
              <span>© {currentYear} Quest-Lock</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
